
const initialState = {
  loading: true,
  response: false
};

export default (state = initialState, action = {}) => {

  switch (action.type) {

  case 'FETCHING_PROFILE':

    return initialState;

  case 'FETCH_PROFILE_SUCCESS':

    return Object.assign({}, state, {
      loading: false,
      ...action.data.data
    });

  /*************************Change action states START ***************************/
      case 'CHANGE_PASSWORD_PENDING': 
        return Object.assign({}, state, {loading: true});

      case 'CHANGE_PASSWORD_FULFILLED':
        return Object.assign({}, state, {
          loading: false,
          response: action.payload
        });

      case 'CHANGE_PASSWORD_REJECTED':
        return {
          isRejected: true,
          error: 'Fetch Question action Failed'
        };  
  /*************************Fetch Question action states END ***************************/

  case 'CHANGE_PASSWORD_CLEAR_RESPONSE' :
    return Object.assign({}, state, {
      response: false
    });

  default:
    return Object.assign({}, state, {
      loading: false
    });
  }

};



// WEBPACK FOOTER //
// ./src/features/profile/reducer.js